import {
  Button,
  Card,
  Empty,
  Input,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import InstitutionCreateModal from "./components/InstitutionCreateModal";
import { getAllInstitutions } from "../../../api/institutionApi";
import { useOpenRoute } from "../../../utils/openRouteUtils";

const { Title, Text } = Typography;

function getTypeColor(type) {
  switch (type) {
    case "TRADING_HOUSE":
      return "green";

    default:
      return "blue";
  }
}

export default function InstitutionsPage() {
  const openRoute = useOpenRoute();

  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const loadInstitutions = async () => {
    try {
      setLoading(true);
      const data = await getAllInstitutions();
      setInstitutions(Array.isArray(data) ? data : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInstitutions();
  }, []);

  const filteredData = useMemo(() => {
    const q = keyword.trim().toLowerCase();
    if (!q) return institutions;

    return institutions.filter((item) => {
      const name = item?.name?.toLowerCase() || "";
      const type = item?.type?.toLowerCase() || "";
      return name.includes(q) || type.includes(q);
    });
  }, [institutions, keyword]);

  const columns = [
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <button
          type="button"
          onClick={(event) =>
            openRoute(`/admin/institutions/${record.id}`, event)
          }
          className="cursor-pointer border-0 bg-transparent p-0 text-left text-[15px] font-semibold text-slate-800 hover:text-blue-600"
        >
          {record.name}
        </button>
      ),
    },
    {
      title: "Төрөл",
      dataIndex: "type",
      key: "type",
      width: 180,
      render: (value) => <Tag color={getTypeColor(value)}>{value || "-"}</Tag>,
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 100,
    },
  ];

  return (
    <div className="space-y-5 p-5">
      <Card className="rounded-2xl shadow-sm">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <Title level={3} className="!mb-1">
              Байгуулгууд
            </Title>
            <Text className="text-slate-500">
              Байгууллагын жагсаалт болон шинээр байгууллага үүсгэх хэсэг
            </Text>
          </div>

          <Space wrap>
            <Input
              allowClear
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              prefix={<SearchOutlined />}
              placeholder="Нэрээр хайх"
              style={{ width: 260 }}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setCreateOpen(true)}
            >
              Байгууллага нэмэх
            </Button>
          </Space>
        </div>
      </Card>

      <Card className="rounded-2xl shadow-sm">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 100, showSizeChanger: false }}
          locale={{
            emptyText: <Empty description="Байгууллага олдсонгүй" />,
          }}
        />
      </Card>

      <InstitutionCreateModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onSuccess={loadInstitutions}
      />
    </div>
  );
}